<template>
  <div>
    <div
      v-if="jobDetail"
      class="box rounded-10 pb-3 is-shadowless"
      :class="screen === 'mobile' ? ' px-2 pb-3' : ''"
    >
      <div v-if="jobDetail.is_expired" class="notification is-danger is-light">
        <strong>This Job Has expired</strong>
      </div>
      <div class="columns is-flex mb-1 has-padding-10">
        <img
          class="image outline rounded-10 is-paddingless"
          :src="get(jobDetail, 'organization.logo') || ''"
          :class="screen === 'mobile' ? 'is-64x64' : 'is-96x96'"
        />
        <div class="column py-0 place-item-center">
          <div class="is-size-5 has-text-weight-bold is-size-6-mobile">
            {{ jobDetail.job_title }}
            <span v-if="['Newspaper', 'Web'].includes(jobDetail.job_source)">
              <vue-icon-base
                height="20"
                width="20"
                :path="$options.icons[$kc('uni-newspaper')]"
              >
              </vue-icon-base>
            </span>
          </div>
          <div
            class="is-size-7 has-text-weight-bold pointer"
            v-text="
              jobDetail.org_alt_name
                ? jobDetail.org_alt_name
                : get(jobDetail, 'organization.name')
            "
            @click="
              jobDetail.organization.slug
                ? $router.push(
                    localePath(
                      `/employer/detail/${jobDetail.organization.slug}`
                    )
                  )
                : ''
            "
          ></div>
          <p>
            <span class="has-text-weight-bold is-size-7">
              {{ $t('Deadline') }}:
            </span>
            &nbsp;
            <span>
              <span class="is-size-7">
                {{ $options.getMoment(jobDetail.deadline) || '' }}
              </span>
            </span>
          </p>
        </div>
        <div class="column is-1-mobile is-paddingless">
          <span
            v-if="$store.state.auth.loggedIn && !$auth.user.employer_profile"
          >
            <a
              class="has-text-success is-pulled-right has-padding-top-10"
              @click="toggleLike(jobDetail)"
            >
              <vue-icon-base
                height="20"
                width="20"
                :path="
                  jobDetail.liked
                    ? $options.icons[$kc('thumbs-up-fill')]
                    : $options.icons[$kc('thumbs-up')]
                "
                icon-color="green"
              >
              </vue-icon-base>
            </a>
          </span>
          <span v-else>
            <a
              class="has-text-success is-pulled-right pt-10-mobile"
              @click="notify"
            >
              <vue-icon-base
                height="20"
                width="20"
                :path="$options.icons[$kc('thumbs-up')]"
                icon-color="green"
              >
              </vue-icon-base>
            </a>
          </span>
        </div>
      </div>
      <div
        class="outline box rounded-10 is-shadowless mb-2"
        :class="screen === 'mobile' ? 'px-1 py-0' : ''"
      >
        <div class="columns is-size-7 mb-0">
          <div class="column">
            <div class="columns">
              <div class="column" :class="screen === 'mobile' ? 'pb-0' : ''">
                <table class="table is-borderless is-hoverable is-full-width">
                  <tr class="is-hovered">
                    <td style="width: 95px">{{ $t('Vacancy') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">{{ jobDetail.vacancies }} people</td>
                  </tr>
                  <tr class="is-hovered">
                    <td style="width: 95px">{{ $t('location') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      {{
                        jobDetail.job_locations.length
                          ? jobDetail.job_locations
                              .map(address => ' ' + address.full_address)
                              .toString()
                          : ''
                      }}
                    </td>
                  </tr>
                  <tr class="is-hovered">
                    <td style="width: 95px">{{ $t('salary') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      <div v-text="get(jobDetail, 'offered_salary')"></div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="column" :class="screen === 'mobile' ? 'pt-0' : ''">
                <table class="table is-borderless is-hoverable is-full-width">
                  <tr
                    v-if="get(jobDetail, 'setting.is_age_specific')"
                    class="is-hovered"
                  >
                    <td style="width: 95px">
                      {{ $t('Age') }}
                    </td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      <div v-if="get(jobDetail, 'setting.min_age')">
                        {{ 'Above ' + jobDetail.setting.min_age }}
                      </div>
                      <div v-if="get(jobDetail, 'setting.max_age')">
                        {{ 'Below ' + jobDetail.setting.max_age }}
                      </div>
                    </td>
                  </tr>
                  <tr class="is-hovered">
                    <td style="width: 95px">{{ $t('Gender') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      {{
                        $t(get(jobDetail, 'setting.gender')) ||
                        $t('No Preference')
                      }}
                    </td>
                  </tr>
                  <tr class="is-hovered">
                    <td style="width: 95px">{{ $t('Education') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      <div v-if="get(jobDetail, 'is_education_specific')">
                        {{
                          jobDetail.education_level +
                          ' (' +
                          $t('Required') +
                          ')'
                        }}
                      </div>
                      <div v-else>
                        {{
                          jobDetail.education_level
                            ? jobDetail.education_level +
                              ' (' +
                              $t('preferred') +
                              ')'
                            : $t('Not Required')
                        }}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-size-7 mb-0">
          <div class="column">
            <div class="columns">
              <div class="column" :class="screen === 'mobile' ? 'pb-0' : ''">
                <table class="table is-borderless is-hoverable is-full-width">
                  <tr class="is-hovered" style="width: 95px">
                    <td style="width: 95px">{{ $t('Job Level') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      {{
                        $t(
                          $options.getNameByValue(
                            $options.jobLevelChoices,
                            jobDetail.job_level
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr class="is-hovered">
                    <td style="width: 95px">{{ $t('Job Type') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      {{
                        $t(
                          $options.getNameByValue(
                            $options.availableForChoices,
                            jobDetail.available_for[0]
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr class="is-hovered">
                    <td style="width: 95px">{{ $t('Shift') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      {{ $t(jobDetail.preferred_shift) }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="column" :class="screen === 'mobile' ? 'pt-0' : ''">
                <table class="table is-borderless is-hoverable is-full-width">
                  <tr class="is-hovered">
                    <td style="width: 95px">
                      <div>
                        {{ $t('Work Experience') }}
                      </div>
                    </td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      <div
                        v-if="get(jobDetail, 'setting.is_experience_required')"
                      >
                        {{
                          get(jobDetail, 'setting.min_experience_months') / 12 +
                          ' Years ' +
                          ' (' +
                          $t('Required') +
                          ')'
                        }}
                      </div>
                      <div v-else>
                        {{
                          get(jobDetail, 'setting.min_experience_months')
                            ? get(jobDetail, 'setting.min_experience_months') /
                                12 +
                              ' Years (' +
                              $t('preferred') +
                              ')'
                            : $t('Not Required')
                        }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="jobDetail.setting.required_two_wheeler"
                    class="is-hovered"
                  >
                    <td style="width: 95px">
                      {{ $t('Require Two Wheeler') }}
                    </td>
                    <td style="width: 5px">:</td>
                    <td
                      v-if="jobDetail.setting.required_two_wheeler === true"
                      class="is-bold"
                    >
                      Yes
                    </td>
                    <td v-else>No</td>
                  </tr>
                  <tr
                    v-if="jobDetail.document_categories.length"
                    class="is-hovered"
                  >
                    <td style="width: 95px">{{ $t('Documents') }}</td>
                    <td style="width: 5px">:</td>
                    <td class="is-bold">
                      <span
                        v-for="(item, index) in jobDetail.document_categories"
                        :key="index"
                      >
                        {{ $t(item) }}
                        <span
                          v-if="
                            index + 1 < jobDetail.document_categories.length
                          "
                        >
                          {{ ', ' }}</span
                        >
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="px-2">
          <hr
            v-if="jobDetail.skills.length"
            class="has-margin-bottom-10 mt-0"
          />
          <div v-if="jobDetail.skills.length">
            <p class="pb-2 is-size-7 has-text-weight-bold">
              {{ $t('Technical skills') }}<span>:</span>
            </p>
            <span
              v-for="(item, index) in jobDetail.skills"
              :key="index"
              :title="item"
              class="tag word-break border-1 px-2 mr-3 mb-3"
            >
              {{ item }}
            </span>
          </div>
          <hr
            v-if="jobDetail.personal_qualities.length"
            class="has-margin-bottom-10 mt-0"
          />
          <div v-if="jobDetail.personal_qualities.length">
            <p class="pb-2 is-size-7 has-text-weight-bold">
              {{ $t('Personal Quality') }}<span>:</span>
            </p>
            <span
              v-for="(item, index) in jobDetail.personal_qualities"
              :key="index"
              class="tag word-break border-1 px-2 mr-3 mb-3"
            >
              {{ item }}
            </span>
          </div>
          <hr
            v-if="jobDetail.work_standards.length"
            class="has-margin-bottom-10 mt-0"
          />
          <div v-if="jobDetail.work_standards.length">
            <p class="pb-2 is-size-7 has-text-weight-bold">
              {{ $t('Work Standards') }}<span>:</span>
            </p>
            <span
              v-for="(item, index) in jobDetail.work_standards"
              :key="index"
              class="tag word-break border-1 px-2 mr-3 mb-3"
            >
              {{ item }}
            </span>
          </div>
          <hr
            v-if="jobDetail.required_knowledge.length"
            class="has-margin-bottom-10 mt-0"
          />
          <div v-if="jobDetail.required_knowledge.length">
            <p class="pb-2 is-size-7 has-text-weight-bold">
              {{ $t('Required Knowledge') }}<span>:</span>
            </p>
            <span
              v-for="(item, index) in jobDetail.required_knowledge"
              :key="index"
              class="tag word-break border-1 px-2 mr-3 mb-3"
            >
              {{ item }}
            </span>
          </div>
          <hr
            v-if="jobDetail.benefits.length"
            class="has-margin-bottom-10 mt-0"
          />
          <div v-if="jobDetail.benefits.length">
            <p class="pb-2 is-size-7 has-text-weight-bold">
              {{ $t('Benefits') }}<span>:</span>
            </p>
            <span
              v-for="(item, index) in jobDetail.benefits"
              :key="index"
              class="tag word-break border-1 px-2 mr-3 mb-3"
            >
              {{ item }}
            </span>
          </div>
        </div>
      </div>
      <div class="column pl-2 is-bold">
        {{ $t('Job Description') }}
      </div>
      <div
        class="is-12 mx-0 font-09 is-top-paddingless pl-5 column is-size-7-mobile"
        v-html="modifyBlogBody(jobDetail.description)"
      ></div>
      <hr class="hr-line mb-4" />
      <div
        class="columns has-padding-bottom-20-mobile has-padding-top-20-mobile has-padding-right-10-mobile has-padding-left-10-mobile"
      >
        <span
          v-if="!jobDetail.is_expired"
          :class="screen === 'mobile' ? '' : 'column is-9 pt-4 pb-5'"
        >
          <button
            v-if="$store.state.auth.loggedIn && !$auth.user.employer_profile"
            class="button has-padding-5-mobile"
            :class="jobDetail.applied ? 'is-success' : 'is-jobseeker'"
            :disabled="
              jobDetail.applied ||
              $auth.user.employer_profile ||
              $auth.user.referrer_profile
            "
            @click="openPopup(jobDetail.id)"
            v-text="jobDetail.applied ? $t('Applied') : $t('applyNow')"
          ></button>
          <button
            v-else-if="jobDetail.slug === 'spa-and-beautician-2'"
            class="button is-jobseeker"
            @click="showSpa"
            v-text="$t('applyNow')"
          ></button>
          <button
            v-else
            class="button is-jobseeker"
            @click="notifyApply"
            v-text="$t('applyNow')"
          ></button>
        </span>
        <!-- <span
          :class="
            screen === 'mobile'
              ? 'is-pulled-right pt-2'
              : 'column is-3 has-text-left has-margin-top-10'
          "
        >
          <span v-show="showAddthis">
            <add-this></add-this>
          </span>
        </span> -->
      </div>
      <JobApplyConfirmation
        v-if="confirmApply"
        :selected-job="jobDetail"
        :modal-id="jobDetail.id"
        @close="confirmApply = false"
      ></JobApplyConfirmation>
    </div>
    <refer-a-friend-form
      v-if="openReferForm"
      :job-detail="jobDetail.id"
      @close="openReferForm = false"
    ></refer-a-friend-form>
    <job-apply-base
      v-if="jobApplyForm.display"
      :next-component="nextComponent"
      :initial-form="initialForm"
      :job-detail="jobApplyForm.jobDetail"
      @success="
        initialForm = false
        jobApplyForm.display = false
        applyJob(jobApplyForm.jobDetail)
      "
      @close="jobApplyForm.display = false"
    ></job-apply-base>
    <div v-if="$auth.loggedIn && $auth.user.jobseeker_profile">
      <document
        :class="isShow === true ? 'is-active' : ''"
        :isEdit="false"
        :user-info="jobseekerInfo"
        :document-error-msg="documentErrorMsg"
        @closeThis="isShow = false"
      ></document>
    </div>
    <div class="modal" :class="applyOnlineAlternative ? 'is-active' : ''">
      <div class="modal-background columns is-flex is-vcentered">
        <div class="modal-content scrolls column is-one-third">
          <div class="box">
            <div class="modal-head">
              <h2>
                <b>{{ $t('Applying Procedure') }}</b>
              </h2>
              <hr class="mt-2" />
            </div>
            <div class="content">
              <div
                v-html="modifyBlogBody(jobDetail.apply_online_alternative)"
              ></div>
              <button
                class="modal-close is-large"
                @click="applyOnlineAlternative = false"
              ></button>
              <div class="btns has-text-right">
                <button
                  class="mt-4 pointer"
                  @click="applyOnlineAlternative = false"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobApplyConfirmation from '@/components/Job/Apply/JobApplyConfirmation.vue'
// import AddThis from '@/components/Commons/AddThis'
import VueIconBase from '@/components/Commons/VueIconBase'
import {
  uniShareAlt,
  thumbsUp,
  thumbsUpFill,
  uniNewspaper
} from '@/helpers/icons'
import { getNameByValue } from '@/helpers/utils/filter'
import JobApplyBase from '@/components/Job/Apply/Base'
import Document from '@/components/Jobseeker/Profile/Document/Document.vue'
import { truncateChars } from '@/helpers/utils/common'
import { getMoment } from '@/helpers/utils/date'
import {
  jobLevelChoices,
  availableForChoices
} from '@/helpers/constants/jobseeker'
import { mapGetters } from 'vuex'
export default {
  components: {
    JobApplyBase,
    VueIconBase,
    // AddThis,
    JobApplyConfirmation,
    Document
  },
  icons: {
    uniShareAlt,
    thumbsUp,
    thumbsUpFill,
    uniNewspaper
  },
  jobLevelChoices,
  availableForChoices,
  getMoment,
  getNameByValue,
  truncateChars,
  props: {
    isLikedJobs: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // showAddthis: false,
      loading: false,
      getdateformat: '',
      initialForm: false,
      confirmApply: false,
      nextComponent: '',
      jobApplyForm: {
        jobDetail: {},
        display: false
      },
      openReferForm: false,
      isShow: false,
      jobseekerInfo: {},
      showConfirmModal: false,
      documentErrorMsg: [],
      applyOnlineAlternative: false
    }
  },
  mounted() {
    const links = document.querySelectorAll('a')
    links.forEach(link => {
      if (link.href.includes('http')) {
        link.setAttribute('target', '_blank')
      }
    })
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' }),
    ...mapGetters({
      getCurrentJobDetail: 'job/getCurrentJobDetail'
    }),
    jobDetail() {
      return this.get(this.$store.state.collection.collectionResponses, [
        'jobDetails'
      ])
    },
    showThirdBox() {
      return (
        this.jobDetail.document_categories.length ||
        this.jobDetail.benefits.length ||
        this.get(this.jobDetail, 'setting.required_two_wheeler')
      )
    }
  },
  // created() {
  //   this.showStatus()
  // },
  methods: {
    modifyBlogBody(url) {
      let endpoint = url
      endpoint = endpoint.replace('oembed', 'iframe')
      const iframeRegex = /<iframe[^>]+src="([^"]+)"/g
      const imgRegex = /<img[^>]+src="([^"]+)"/g
      endpoint = endpoint.replace(iframeRegex, (match, src) => {
        return match.replace(src, `${src}" width="100%" height="370"`)
      })
      endpoint = endpoint.replace(imgRegex, (match, src) => {
        return match.replace(src, `${src}" width="100%" height="370"`)
      })
      endpoint = endpoint.replace('watch?v=', 'embed/')
      endpoint = endpoint.replace(
        /<p>(https?:\/\/[^<]+)<\/p>/g,
        (match, url) => {
          return `<a href="${url}" target="_blank">${url}</a>`
        }
      )
      endpoint = endpoint.replace(
        /<h1>/g,
        '<h1 class="is-size-4 has-text-weight-semibold">'
      )
      endpoint = endpoint.replace(
        /<h2>/g,
        '<h2 class="is-size-5 has-text-weight-semibold">'
      )
      endpoint = endpoint.replace(
        /<h3>/g,
        '<h3 class="is-size-6 has-text-weight-semibold">'
      )
      endpoint = endpoint.replace(
        /<(?!\/?strong)([\s]?)*<\/[^>]*>/g,
        '<br style="margin-bottom: 10px;">'
      )
      endpoint = endpoint.replace(/<p>\s*<\/p>/g, '</br>')
      return endpoint
    },
    // showStatus() {
    //   if (this.jobDetail.status === 'Published') {
    //     this.showAddthis = true
    //   }
    // },
    openPopup(id) {
      if (!['', '<p></p>'].includes(this.jobDetail.apply_online_alternative)) {
        this.applyOnlineAlternative = true
      } else if (this.jobDetail.slug === 'spa-and-beautician-2') {
        this.showSpa()
      } else {
        this.confirmApply = true
      }
    },
    showSpa() {
      window.open(
        'https://rojgari.com/training/spa-and-beauty-training',
        '_blank'
      )
    },
    closePopup() {
      this.isShow = false
      const modal = document.getElementById(`${this.jobDetail.id}`)
      modal.style.display = 'none'
    },
    applyJob(job) {
      if (job.is_expired) {
        return this.notifyError(this.$t('ThisJobIsExpired'))
      }
      this.fetchRequiredFields(job)
    },
    fetchRequiredFields(job) {
      if (this.loading) return
      this.loading = true
      if (this.$route.query && this.$route.query.referred_by) {
        this.endpoint = `/api/v1/job/${job.slug}/apply/?referred_by=${this.$route.query.referred_by}`
      } else {
        this.endpoint = `/api/v1/job/${job.slug}/apply/`
      }
      this.$axios
        .$post(this.endpoint)
        .then(response => {
          this.notifyUser('Successfully applied to this job')
          this.jobApplyForm.display = true
          this.nextComponent = 'apply-success'
        })
        .catch(error => {
          if (error.response.status === 428) {
            if (error.response.data.code === 'profile_fields_required') {
              this.requiredFields = error.response.data.fields
            } else if (error.response.data.code === 'documents_required') {
              this.getJobSeekerInfo()
              this.documentErrorMsg = error.response.data.document_categories
              this.requiredFields = error.response.data.documents_required
              this.isShow = true
              this.notifyError(
                `Please upload required documents : ${error.response.data.document_categories}`
              )
            } else if (error.response.data.code === 'user_blocked') {
              this.notifyError(`User blocked : ${error.response.data.message}`)
            } else {
              this.jobApplyForm.display = true
              this.nextComponent = 'questions'
            }
          } else if (error.response.status === 412) {
            this.jobApplyForm.jobDetail = job
            this.$axios.get(`/api/v1/users/me/`).then(response => {
              this.userData = response.data
              if (!this.userData.has_preferred_locations) {
                this.$router.push(
                  this.localePath({
                    name: 'signup-prefered-location'
                  })
                )
              } else if (!this.userData.has_preferred_jobs) {
                this.$router.push(
                  this.localePath({
                    name: 'signup-prefered-job-category'
                  })
                )
              } else if (!this.userData.has_filled_description_form) {
                this.$router.push(
                  this.localePath({
                    name: 'signup-basic-information'
                  })
                )
              } else if (!this.userData.has_filled_description_form) {
                this.$router.push(
                  this.localePath({
                    name: 'signup-working-status'
                  })
                )
              } else if (this.userData.has_filled_initial_form) {
                this.initialForm = true
              } else {
                this.initialForm = true
              }
            })
          } else {
            this.jobApplyForm.display = true
            this.jobApplyForm.jobDetail = job
            this.nextComponent = 'questions'
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    toggleLike(job) {
      const status = job.liked ? 'unlike' : 'like'
      const likeApi = `/api/v1/job/search/${job.slug}/${status}/`
      this.$axios.post(likeApi).then(({ data }) => {
        this.$store.commit('collection/modifyLeaf', {
          path: `jobDetails.liked`,
          data: data.liked
        })
      })
    },
    notify() {
      if (!this.$store.state.auth.loggedIn) {
        this.notifyUser(this.$t('Please Log in to proceed.'))
        this.setDialog({ display: true, type: 'sign-in' })
      } else {
        this.notifyError(this.$t('You cannot like this job.'))
      }
    },
    notifyApply() {
      if (!this.$store.state.auth.loggedIn) {
        this.notifyUser(this.$t('Please Log in to proceed.'))
        this.setDialog({ display: true, type: 'sign-in' })
      } else {
        this.notifyError(this.$t('You cannot apply for this job.'))
      }
    },
    getJobSeekerInfo() {
      this.$axios.$get('/api/v1/jobseekers/me/overview/').then(response => {
        this.jobseekerInfo = response
      })
    }
  }
}
</script>

<style scoped>
.is-divider {
  width: 100%;
  height: 2px;
  background-color: black;
}
.rounded-10 {
  border-radius: 10px;
}
.table.is-borderless tr td {
  border-style: hidden;
}

.is-hovered {
  transition: 0.3s;
}
.is-hovered:hover {
  background-color: #eee;
}
.is-bold {
  font-weight: 600;
}
.place-item-center {
  display: flex;
  flex-direction: column;
  place-content: center;
}
.scrolls {
  overflow-y: scroll;
  scrollbar-width: none;
}
.scrolls::-webkit-scrollbar {
  display: none;
}
</style>
